import { render, staticRenderFns } from "./BlocDataTable.vue?vue&type=template&id=cf20b0cc"
import script from "./BlocDataTable.vue?vue&type=script&lang=js"
export * from "./BlocDataTable.vue?vue&type=script&lang=js"
import style0 from "./BlocDataTable.vue?vue&type=style&index=0&id=cf20b0cc&prod&language=scss&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports